// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0b23efc6","227":"0dddf22a","232":"8f6045ec","237":"539f8aa8","357":"4c368a2e","383":"4185d66f","496":"3f4031c4","512":"37a30209","526":"a045cce5","733":"811976d4","753":"020efa53","792":"97eae09f","854":"5cc2dcad","872":"8e23865b","918":"02e63783"}[chunkId] + ".chunk.js";
};